export default {
  contingent_configcontingent: {
    show: {
      page_title: 'Configuration de contingent - détail'
    },
    list: {
      page_title: 'Liste des configurations'
    },
    edit: {
      page_title: 'Configuration de contingent - édition'
    },
    create: {
      page_title: 'Configuration de contingent - création'
    }
  },
  hotel_configcontingent: {
    show: {
      page_title: 'Configuration de contingent - détail'
    },
    list: {
      page_title: 'Liste des configurations'
    },
    edit: {
      page_title: 'Configuration de contingent - édition'
    },
    create: {
      page_title: 'Configuration de contingent - création'
    }
  }
}
